export const newOrder = [
  "criteria",
  "applicants",
  "property",
  "property_group",
  "unit",
  "started_at",
  "submitted_at",
  "updated_at",
  "status"
];
